import React from 'react'
import PropTypes from 'prop-types'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'

const DoxExplorerTableMessage = (props) => {
    const translateString = useTranslationContext()

    const getParams = (i) => {
        if (props.params && props.params.length > i) {
            return props.params[i]
        }
        return {}
    }

    return (
        <div className='doxe-files-table'>
            {props.labelKeys.map((lk, i) =>
                <div className='doxe-msg' key={`doxemsg-key-${i}`}>
                    {translateString(lk, getParams(i))}
                </div>
            )}
        </div>
    )
}

DoxExplorerTableMessage.propTypes = {
    labelKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    params: PropTypes.arrayOf(PropTypes.object)
}   

export default DoxExplorerTableMessage;